export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/spearmint-flavor.b5ab7d3a919e25f2afa45504ef4550ea.png";